import { useState } from "react";
import { toast } from "react-toastify";
import Table from "../../../../components/elements/table/Table";
import { formatNumber, getPaginationRange, getSortQuery, handleFilterChange } from "../../../../helpers";
import { useDebounce } from "../../../../hooks/useDebounce";
import { classNames } from "../../../../helpers/classNames";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import TableControls from "../../../elements/TableControls";
import { achievementList } from "../../../../services/achievementService";
import dayjs from "dayjs";

const Achievements = ({ userId = null }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [filters, setFilters] = useState({
    limit: 100,
    page: 1,
    // sortQuery: "-createdAt",
  });

  const { data, isFetching, isLoading, error } = useQuery({
    queryKey: ["achievements", filters, search],
    queryFn: async () => {
      const { role = [], statusCode = [], ...restFilters } = filters || {};

      const queryParams = {
        ...restFilters,
        ...(search && { keyword: search }),
        userId
      };

      const res = await achievementList(queryParams);
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs || {};
    },
  });

  let tableHeadData = [
    {
      _id: 1,
      name: "Badge",
      align: "left",
    },
    {
      _id: 2,
      name: "Awarded On",
      align: "center",
    },
    {
      _id: 3,
      name: "Badge Earned At (Pts)",
      align: "center",
    },
  ];

  // Table Body Data =====================>
  let tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "imageWithText",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.badge?.name,
          image:item?.badge?.image?.url
        },
        {
          _id: 2,
          type: "text",
          align: "center",
          cellClass: "!min-w-[100px]",
          data: dayjs(item?.date).format("DD MMM, YYYY"),
        },
        {
          _id: 3,
          type: "text",
          align: "center",
          cellClass: "!min-w-[100px]",
          data: item?.points
        },
      ],
    };
  });


  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      {/* <div className="flex items-center gap-3">
        <TableControls
          limit={filters?.limit}
          totalDocs={data?.metadata?.totalDocs}
          onLimitChange={(val) => handleFilterChange("limit", val, setFilters)}
          onSearch={(val) => {
            setKeyword(val);
            handleFilterChange("page", 1, setFilters);
          }}
        />
      </div> */}
      <h3 className="text-[30px] font-bold text-primary mb-8">Achievements</h3>
      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        totalDataCount={data?.metadata?.totalDocs}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        handleOrdering={(val) => {
          console.log(val);
        }}
        isFetching={isFetching}
        isOrderingDisabled={true}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
        showingData={getPaginationRange(filters?.page, filters?.limit, data?.metadata?.totalDocs)}
      />
    </div>
  );
};

export default Achievements;
